import useAsyncTask from "@agrigate/shared/lib/hooks/use-async-task";
import { LoginForm } from "@agrigate/shared-web-ui/lib/LoginGuard";
import { sessionAtom } from "@agrigate/shared-web-ui/lib/stores/session";
import { useAtom } from "jotai";
import type { PropsWithChildren, ReactElement } from "react";
import rpc from "../utils/rpc";

export default function LoginGuard(
    p: PropsWithChildren<object>,
): ReactElement | null {
    const [session, setSession] = useAtom(sessionAtom);

    const getTokenT = useAsyncTask(async () => {
        const res = await rpc.users.getSelf({});
        setSession(res);
    });

    if (getTokenT.runState === "failed" && !session?.token)
        return <LoginForm />;

    if (getTokenT.runState !== "complete") return null;

    return <>{p.children}</>;
}
